import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CollectionApiResponse} from '../../../lib/util/api-response';
import {SpesenItem} from './spesen.model';
import { HttpClient } from '@angular/common/http';
import {SpesenartItem} from './spesenart.model';
import {CacheItem} from "./cache.model";
import {DialogData} from "./components/zeiterfassung-formdialog-neu/zeiterfassung-formdialog-neu.component";
import {DashboardItem} from "../landingpage/dashboard.model";

type caches = CollectionApiResponse<CacheItem>;
type cacheNodes = CollectionApiResponse<DashboardItem>;

@Injectable({ providedIn: 'root'})

export class CacheService {

  constructor(private http: HttpClient) {}


  public addCache(cache: DialogData): Observable<caches> {
    let userId = null;
    if (isNaN( Number(sessionStorage.getItem('zeitUserId'))) === false && sessionStorage.getItem('zeitUserId') !== null){
      userId = sessionStorage.getItem('zeitUserId');
    }
    else{
      userId = sessionStorage.getItem('userId');
    }
    // tslint:disable-next-line:max-line-length
    return this.http.post(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/zeiterfassung/addCache.php?userId=${userId}&${sessionStorage.getItem('session')}`, cache) as Observable<caches>;
  }

  public loadCache(): Observable<cacheNodes> {
    let userId = null;
    if (isNaN( Number(sessionStorage.getItem('zeitUserId'))) === false && sessionStorage.getItem('zeitUserId') !== null){
      userId = sessionStorage.getItem('zeitUserId');
    }
    else{
      userId = sessionStorage.getItem('userId');
    }
    // tslint:disable-next-line:max-line-length
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/zeiterfassung/getCache.php?userId=${userId}&${sessionStorage.getItem('session')}`) as Observable<cacheNodes>;
  }

  public loadTaetCache(prjId: number, eingabe: string): Observable<string[]> {
    let userId = null;
    if (isNaN( Number(sessionStorage.getItem('zeitUserId'))) === false && sessionStorage.getItem('zeitUserId') !== null){
      userId = sessionStorage.getItem('zeitUserId');
    }
    else{
      userId = sessionStorage.getItem('userId');
    }
    if(!eingabe){
      eingabe = '';
    }
    // tslint:disable-next-line:max-line-length
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/zeiterfassung/getTaetCache.php?userId=${userId}&${sessionStorage.getItem('session')}&prjId=${prjId}&eingabe=${eingabe}`) as Observable<string[]>;
  }


}
